/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
    .controller('CheckoutOrderTimeslotController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {
        $scope.Model = $scope.Model || {};
        $scope.Control = $scope.Control || {};
        
        if (!$scope.Config.IsTimeslotEnabled)
            return;

        var validators = [];
        var initiallyValidated = false;

        var controlName = 'OrderTimeslot';
        $scope.registerControl(controlName, $element.get(0));

        var savedOrderTimeslot = undefined;
        $scope.Control.SelectedOrderTimeslot = undefined;

        var setSelectedOrderTimeslot = function (orderTimeslot) {

            if (orderTimeslot == null || orderTimeslot.TimeslotId <= 0) return;

            var deferred = $q.defer();

            var orderTimeslot = _.first(_.filter($scope.Model.Data.OrderTimeslot, function (x) { return x.IsValid && x.FromDateTime === orderTimeslot.FromDateTime && x.ToDateTime === orderTimeslot.ToDateTime; }));

            ControlService.invokeCheckout($scope, $element, 'SetOrderTimeslot', orderTimeslot).then(function (setResponse) {
                $scope.setControlValue(controlName, orderTimeslot);

                savedOrderTimeslot = $scope.Control.SelectedOrderTimeslot = orderTimeslot;

                deferred.resolve(true);
                $scope.Control.Loading = false;
                if ($scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) == 'function') {
                    $scope['Order'].Wrapper.reload().then(function (orderResponse) {
                        $scope.Control.Loading = false;
                    }, function (orderError) {
                        $scope.Control.Loading = false;
                        throw orderError;
                    });
                }
                Cookies.set("ForceClearCartLocalStorage", 1, { samesite: 'Lax' });
            }, function (error) {
                deferred.reject(error);
                $scope.Control.Loading = false;
            });

            return deferred.promise;
        };
        var applyModel = function () {

            var selectedTimeslot;
            if ($scope['Order'] && $scope['Order'].Current && $scope['Order'].Current.OrderTimeslot)
                selectedTimeslot = $scope['Order'].Current.OrderTimeslot;

            var groupByDate = function groupByDate(messages) {
                var grouped = [];
                var previousDate, currentDate, i = 0;
                _.forEach(messages, function (msg) {
                    currentDate = (new Date(msg.FromDateTime)).setHours(0, 0, 0, 0);

                    if (currentDate > previousDate) i++;
                    if (!grouped[i]) grouped[i] = [];

                    grouped[i].push(msg);

                    previousDate = currentDate;
                });


                return grouped;
            };

            $scope.Model.Data.groupedData = groupByDate($scope.Model.Data.OrderTimeslot);

            $scope.Control.hasAvailable = function (timeslotGroup) {
                if (timeslotGroup.length > 0) {
                    for (var j = 0; j < timeslotGroup.length; j++) {
                        if (timeslotGroup[j].IsValid)
                            return true;
                    }
                    return false;
                }
            };

            $scope.Control.isToday = function (timeslotGroup) {
                var today = new Date();
                var selectedDay = new Date(timeslotGroup[0].FromDateTime);

                var bool = (today.getFullYear() == selectedDay.getFullYear()
                            && today.getMonth() == selectedDay.getMonth()
                            && today.getDate() == selectedDay.getDate())

                return bool;
            };

            $scope.Control.isTomorrow = function (timeslotGroup) {
                var today = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
                var selectedDay = new Date(timeslotGroup[0].FromDateTime);

                var bool = (today.getFullYear() == selectedDay.getFullYear()
                            && today.getMonth() == selectedDay.getMonth()
                            && today.getDate() == selectedDay.getDate())

                return bool;
            };

            if (selectedTimeslot == undefined)
                selectedTimeslot = _.first(_.filter($scope.Model.Data.OrderTimeslot, function (x) { return x.IsValid }));

            var orderTimeslot = _.first(_.filter($scope.Model.Data.OrderTimeslot, function (x) { return x.IsValid && x.FromDateTime === selectedTimeslot.FromDateTime && x.ToDateTime === selectedTimeslot.ToDateTime; }));
            if (!orderTimeslot) {

                orderTimeslot = _.first(_.filter($scope.Model.Data.OrderTimeslot, function (x) { return x.IsValid }));

                $scope.Control.setSelectedOrderTimeslot(orderTimeslot);
            }

            savedOrderTimeslot = $scope.Control.SelectedOrderTimeslot = orderTimeslot;
			$scope.setControlValue(controlName, $scope.Control.SelectedOrderTimeslot);

			$scope.Control.reAllign();

        };

        $scope.Control.setSelectedOrderTimeslot = function (orderTimeslot) {

            if (orderTimeslot == null || orderTimeslot.TimeslotId <= 0) return;
            if (savedOrderTimeslot != null)
                if (savedOrderTimeslot.FromDateTime == orderTimeslot.FromDateTime && savedOrderTimeslot.ToDateTime === orderTimeslot.ToDateTime)
                    return;

            setSelectedOrderTimeslot(orderTimeslot).then(function (parameters) {
                $scope.Control.SelectedRequired = false;
                $scope.Control.SelectedInvalid = false;
                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
            });
        };

		$scope.Control.reAllign = function () {

			setTimeout(function () {

				var container = $('.x-checkoutordertimeslot .timeslots-container');
				var selected = $('[name="timeslot"]:checked', container);

				if (selected.length < 1) return;

				selected = selected.closest('li');

				var offset = selected.offset().left - container.offset().left;
				container.animate({ scrollLeft: offset }, 1);

			}, 1);
		};

        $scope.Control.validateField = function (name) {
            if (initiallyValidated) {
                _.first(_.filter(validators, function (x) { return x.name == name; })).fn();
            }
        };

        validators.push({
            name: 'Control.Form.Timeslot',
            fn: function () {
                Validation.reset($scope, 'Control.Form.Timeslot');
                Validation.require($scope, 'Control.Form.Timeslot').then(function (response) { }, function (error) { });
            }
        });

        $element.get(0).validate = function (onComplete) {


            $scope.Control.IsValid = true;
            $scope.Control.SelectedRequired = false;
            $scope.Control.SelectedInvalid = false;

            if ($scope['Order'] && $scope['Order'].Current && !$scope['Order'].Current.IsTimeslotEnabled) {
                if (typeof (onComplete) === 'function') {
                    setTimeout(function () {
                        onComplete($scope.Control.IsValid);
                    }, 200);
                }
                initiallyValidated = true;
                return;
            }

            if ($scope.Control.SelectedOrderTimeslot == null || $scope.Control.SelectedOrderTimeslot == undefined) {
                $scope.Control.IsValid = false;
                $scope.Control.SelectedRequired = true;
            }
            else if ($scope.Control.SelectedOrderTimeslot.TimeslotId < 0) {
                $scope.Control.IsValid = false;
                $scope.Control.SelectedRequired = true;
            }
            else if (!$scope.Control.SelectedOrderTimeslot.IsValid) {
                $scope.Control.IsValid = false;
                $scope.Control.SelectedInvalid = true;
            }
            if (typeof (onComplete) === 'function') {
                setTimeout(function () {
                    onComplete($scope.Control.IsValid);
                }, 200);
            }
            initiallyValidated = true;
        };


        $element.get(0).reload = function () {
            var deferred = $q.defer();

            ControlService.getCheckoutData("GetOrderTimeslotData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);
                applyModel();
                deferred.resolve(response);
                $scope.Control.Loading = false;
            }, function (error) {
                deferred.reject(error);
                $scope.Control.Loading = false;
            });

            return deferred.promise;
        };

		ControlService.getCheckoutData("GetOrderTimeslotData", $scope, $element).then(function (response) {

			$scope.Control.SelectedOrderTimeslot = undefined;
			if ($scope['Order'] && $scope['Order'].Current) {
				if ($scope['Order'].Current.Store.Id !== 0) {
					$scope.Control.SelectedOrderTimeslot = savedOrderTimeslot = $scope['Order'].Current.OrderTimeslot;
				}
			}

			$scope.Model = {};
			angular.extend($scope.Model, response);
			applyModel();
			$scope.Control.Loading = false;
		}, function (error) {
			$scope.Control.Loading = false;
			throw error;
		});
    });
})();